import { api } from '@/shared/api/client';
import { EP } from '@/shared/api/endpoints';

export type CoordinatorState = 'idle' | 'queued' | 'running' | 'busy' | 'offline';

export interface CoordinatorLastRun {
  finished_at?: string;
  rc?: number;
  reason?: string;
  summary?: string;
}

export interface CoordinatorStatus {
  patient_id: number;
  status: CoordinatorState;
  online: boolean;
  running_pid: number | null;
  last_run: CoordinatorLastRun | null;
}

export interface CoordinatorRunResult {
  queued: boolean;
  already?: boolean;
  patient_id: number;
}

/** Текущее состояние координатора для активной карты (X-Patient-Id шлёт client.ts). */
export function fetchCoordinatorStatus() {
  return api.get<CoordinatorStatus>(EP.coordinatorStatus);
}

/** Запросить проход координатора по текущему пациенту. */
export function requestCoordinatorRun() {
  return api.post<CoordinatorRunResult>(EP.coordinatorRun);
}
